import { Registry } from '@react-registry'

export const tableHeaderDeserializer = (el) => {
    return {
        type: 'thead',
        attrs: {}
    }
}

Registry.register(tableHeaderDeserializer, { id: 'table-head', registry: 'v2.deserializer' })